import apiV3 from "../utils/apiV3";

async function doGetFoods(lang = 'en') {
    return await apiV3.get(`envimpact/foods?lang=${lang}`);
}

export {
    doGetFoods
}
